module.exports = __webpack_public_path__ + "static/media/Kathy-Mathieu.351efe39.jpg";